// extracted by mini-css-extract-plugin
module.exports = {"sizing":"_boxes_sizing__Mx3i1","bp-medium":"(min-width: 768px)","wrapper":"Intro_wrapper__R8RQW _boxes_sizing__Mx3i1","heading":"Intro_heading__1kubo"};